import * as _ from 'lodash';

export const getInitialAmountPercent = (data, paramsRoute, fieldName) => {
  const fromCalc = Math.abs(_.get(data, `calculation.${fieldName}`, 0));
  const fromParamsValue = _.get(data, paramsRoute, 0);
  const fromParams = typeof fromParamsValue === 'string' ? fromParamsValue : Math.ceil(fromParamsValue);

  if (fromParams) {
    return {
      value: fromParams.toString().includes('%') ? fromParams.toString().replace('%', '') : fromParamsValue,
      type: fromParams.toString().includes('%') || fromParams !== fromCalc ? `${fieldName}-percent` : `${fieldName}-amount`,
    };
  } else return {
    value: fieldName === 'commission' ? '5' : '0',
    type: fieldName === 'commission' ? `${fieldName}-percent` : `${fieldName}-amount`,
  };
};
